import { API_URL } from "../config"
import { authFetch } from "../utils";

export const getMeteoData = async ({ meteoId, start, end, parameter, format = "json" }) => {
  const url = `${API_URL}/meteos/${meteoId}/observations?start=${encodeURIComponent(
    start
  )}&end=${encodeURIComponent(end)}&parameter=${parameter}&format=${format}`;

  const response = await authFetch(url);
  if (!response.ok) {
    throw new Error("Error al obtener datos meteorológicos");
  }

  if(format === "csv") {
    const blob = await response.blob();
    return blob;
  } else {
    const result = await response.json();
    return result;
  }
}

export const getMeteoDailyRain = async ({ meteoId, start, end }) => {
  const url = `${API_URL}meteos/${meteoId}/observations/daily-rain?start=${encodeURIComponent(
    start
  )}&end=${encodeURIComponent(end)}`;

  const response = await authFetch(url);
  if (!response.ok) {
    throw new Error("Error al obtener la lluvia diaria");
  }

  return await response.blob();
}
